import { DeleteOutlined, DownloadOutlined, EditOutlined, PrinterOutlined, PaperClipOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Checkbox, Col, Divider, FloatButton, Modal, Radio, Row, Space, Tabs, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import { defaultAvatarImg, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, formatVND, thoiGianCongTacCommon } from '../../helpers/common';
import { BacLuongResponse, ChiTietHopDongResponse } from '../../models/hopdong/HopDong';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import LoadingDetailPage from '../../modules/loading/LoadingDetailPage';
import { layCTHopDong, layDsHopDongTheoIdNhanVien } from '../../services/hopdong';
import { layCTNhanVien, xoaNhanVien } from '../../services/nhanvien';
import { xuatBaoCaoChiTietNhanVienMoi } from '../../services/report';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ChungChiBox from './ChungChiBox';
import KhenThuongBox from './KhenThuongBox';
import KyLuatBox from './KyLuatBox';
import NguoiPhuThuocBox from './NguoiPhuThuocBox';
import QuaTrinhDaoTaoVaHocVanBox from './QuaTrinhDaoTaoVaHocVanBox';
import QuaTrinhLamViecVaCongTacBox from './QuaTrinhLamViecVaCongTacBox';
import { useReactToPrint } from 'react-to-print';
import React from 'react';
import InHoSoNhanVienMoi from './InHoSoNhanVienMoi';
import DanhGiaXepLoaiBox from './DanhGiaXepLoaiBox';

const XemNhanVien = () => {
    let navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(true);
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [openModalXuatFile, setOpenModalXuatFile] = useState(false);
    const [loaiMauXuat, setLoaiMauXuat] = useState<number>(2);
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);
    const [bacLuongInfo, setBacLuongInfo] = useState<BacLuongResponse>(new BacLuongResponse);
    const [trangThai, setTrangThai] = useState<number>(-1);

    const menu: any = menuHelper.checkMultiPermission([Links.NhanVien.XoaNhanVien, Links.NhanVien.ChiTiet, Links.Luong.ChiTietThueThang]);
    const dispatch = useDispatch();
    const layDuLieu = async (id: number) => {
        setLoading(true);
        try {
            let kq = await layCTNhanVien(id);
            setNhanVien(kq);
            setTrangThai(kq.trangThai);
            setLoading(false);
        } catch (err) {
            toast.error('Nhân viên không tồn tại');
            navigate(Links.NhanVien.DanhSach);
            setLoading(false);
        }
    }

    const xuatBaoCao = async (idNhanVien: number, hoTen: string, loaiMau: number = 2) => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatBaoCaoChiTietNhanVienMoi(idNhanVien, loaiMau);
            let link = document.createElement('a');

            link.download = loaiMau === 2 ? `SoYeuLyLich_2C_${hoTen}.docx` : `${hoTen}.docx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setOpenModalXuatFile(false);
            dispatch(hideLoadingScreen());
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const layChiTietHopDong = async (idNV: number) => {
        try {
            if (idNV > 0) {
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                if (rs.dsHopDong.length > 0) {
                    var selectDefault = rs.dsHopDong.find(x => x.trangThai === 1) || rs.dsHopDong[0];
                    if (selectDefault.id > 0) {
                        var data = await layCTHopDong(selectDefault.id);
                        setHopDongInfo(data);
                        if (data.bacLuong.length > 0) {
                            setBacLuongInfo(data.bacLuong[0]);
                        }
                    }
                }
            }
        }
        catch (error: any) {
            toast.error('Có lỗi xảy ra, hãy thử lại sau!')
            navigate(Links.NhanVien.DanhSach);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = parseInt(params.get('id') || '');
        if (reload) {
            if (id > 0) {
                setReload(false);
                layDuLieu(id);
                layChiTietHopDong(id);
            } else {
                toast.error('Nhân viên không tồn tại');
                navigate(Links.NhanVien.DanhSach);
            }
        }
    }, [reload]);

    const xoa = async () => {
        try {
            setLoading(true);
            let temp = await xoaNhanVien(nhanVien.id);
            setLoading(false);
            setOpenModalXoa(false);
            if (temp) {
                toast.success('Xóa nhân sự thành công');
                navigate(Links.NhanVien.DanhSach);
            } else {
                toast.error('Xóa nhân sự không thành công! Vui lòng thử lại.');
            }
        }
        catch (error: any) {
            setLoading(false);
            toast.error('Xóa nhân sự không thành công! Vui lòng thử lại.');
        };
    };

    const componentRef = React.createRef<any>();

    const inBaoCao = useReactToPrint({
        content: () => componentRef.current,
    });

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 4: tag = (<Tag color="success">Đã nghỉ hưu</Tag>); break;
        case 1: tag = (<Tag color="processing">Đang làm việc</Tag>); break;
        case 2: tag = (<Tag color="warning">Biệt phái</Tag>); break;
        case 3: tag = (<Tag color="error">Đã nghỉ việc</Tag>); break;
    }

    if (loading) {
        return (
            <LoadingDetailPage title="Thông tin nhân sự" />
        );
    }

    const generateTabs = () => {
        const tabs = [
            {
                key: '1',
                label: 'Thông tin hợp đồng/Quyết định bổ nhiệm',
                children:
                    <div className="card pt-3 pb-2">
                        <div className="tab-content" style={{ marginLeft: "20px", marginRight: "20px" }}>
                            <Row>
                                <Col span="6">
                                    <div>Số hợp đồng/Quyết định bổ nhiệm</div>
                                    <label>
                                        <Space>
                                            {hopDongInfo?.soHopDong}
                                            <Tag color={hopDongInfo?.trangThai ? "green" : "red"}>{hopDongInfo?.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                        </Space>
                                    </label>
                                    <div>Từ ngày</div>
                                    <label>{dateCommon.formatDate(hopDongInfo?.ngayBatDau)}</label>
                                </Col>
                                <Col span="6">
                                    <div>Loại hợp đồng/Quyết định bổ nhiệm</div>
                                    <label>{hopDongInfo?.loaiHopDong}</label>
                                    <div>Đến ngày</div>
                                    <label>{dateCommon.formatDate(hopDongInfo?.ngayKetThuc)}</label>
                                </Col>
                                <Col span="6">
                                    <div>Ngày ký</div>
                                    <label>{dateCommon.formatDate(hopDongInfo?.ngayKy)}</label>
                                    <div>Người ký</div>
                                    <label>{hopDongInfo?.tenNguoiKy}</label>
                                </Col>
                                <Col span="6">
                                    <div>Nơi ký</div>
                                    <label>{hopDongInfo?.noiKy}</label>
                                    <div>Đóng BHXH</div>
                                    <label><Tag color={hopDongInfo?.isDongBHXH ? "green" : "red"}>{hopDongInfo?.isDongBHXH ? "Đóng" : "Không đóng"}</Tag></label>
                                </Col>
                            </Row>
                            <Divider orientation="left" style={{ fontSize: "15px" }}>Quyết định bậc lương</Divider>
                            <Row>
                                {
                                    (bacLuongInfo.mucLuong > 0 && bacLuongInfo.mucLuong != null) &&
                                    <>
                                        <Col span="6">
                                            <div>Số quyết định bậc lương</div>
                                            <label>{bacLuongInfo.soQD}</label>
                                            <div>Từ ngày</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayBatDau)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Hệ số</div>
                                            <label>{bacLuongInfo.heSo}</label>
                                            <div>Đến ngày</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayKetThuc)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Mức lương</div>
                                            <label>{formatVND(bacLuongInfo.mucLuong)}</label>
                                        </Col>
                                        <Col span="6">
                                            <div>Ngày ký quyết định</div>
                                            <label>{dateCommon.formatDate(bacLuongInfo.ngayKyQD)}</label>
                                        </Col>
                                    </>
                                }                                
                            </Row>
                        </div>
                    </div>,
                    condition: !(hopDongInfo.id > 0)
            },
            {
                key: '2',
                label: 'Thông tin Đảng',
                children:
                    <div className="card pt-3 pb-2">
                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                            <Row>
                                <Col span="24">
                                    <div className="mb-1">
                                        <div>Là Đảng viên: <Checkbox checked={nhanVien?.isDangVien} disabled /></div>
                                    </div>
                                </Col>
                            </Row>
                            {
                                nhanVien?.isDangVien &&
                                <Row>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Số thẻ đảng viên</div>
                                            <label>{nhanVien?.ttDangVien.soThe}</label>
                                        </div>
                                        <div className="mb-1">
                                            <div>Chức vụ đảng</div>
                                            <label>{nhanVien?.ttDangVien.tenChucVuDang}</label>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Ngày vào đảng</div>
                                            <label>{dateCommon.formatDate(nhanVien?.ttDangVien.ngayKetNap)}</label>
                                        </div>
                                        <div className="mb-1">
                                            <div>Ngày vào đảng chính thức</div>
                                            <label>{dateCommon.formatDate(nhanVien?.ttDangVien.ngayChinhThuc)}</label>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Tại chi bộ</div>
                                            <label>{nhanVien?.ttDangVien.noiKetNap}</label>
                                        </div>
                                        <div className="mb-1">
                                            <div>Tại chi bộ</div>
                                            <label>{nhanVien?.ttDangVien.noiVaoDangCT}</label>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
            },
            {
                key: '3',
                label: 'Thông tin Đoàn',
                children:
                    <div className="card pt-3 pb-2">
                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                            <Row>
                                <Col span="24">
                                    <div className="mb-1">
                                        <div>Là Đoàn viên: <Checkbox checked={nhanVien?.isDoanVien} disabled /></div>
                                    </div>
                                </Col>
                            </Row>
                            {
                                nhanVien?.isDoanVien &&
                                <Row>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Ngày vào Đoàn</div>
                                            <label>{dateCommon.formatDate(nhanVien?.ttDoanVien.ngayVaoDoan)}</label>
                                        </div>
                                        <div className="mb-1">
                                            <div>Trưởng thành Đoàn: <Checkbox checked={nhanVien?.ttDoanVien.isTruongThanhDoan} disabled /></div>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Nơi kết nạp Đoàn</div>
                                            <label>{nhanVien?.ttDoanVien.noiKetNapDoan}</label>
                                        </div>
                                        {
                                            nhanVien?.ttDoanVien.isTruongThanhDoan &&
                                            <div className="mb-1">
                                                <div>Ngày trưởng thành Đoàn</div>
                                                <label>{dateCommon.formatDate(nhanVien?.ttDoanVien.ngayTruongThanhDoan)}</label>
                                            </div>
                                        }
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Chức vụ Đoàn</div>
                                            <label>{nhanVien?.ttDoanVien.tenChucVuDoan}</label>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
            },
            {
                key: '4',
                label: 'Thông tin Quân đội',
                children:
                    <div className="card pt-3 pb-2">
                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                            <Row>
                                <Col span="24">
                                    <div className="mb-1">
                                        <div>Là Quân nhân: <Checkbox checked={nhanVien?.isQuanNhan} disabled /></div>
                                    </div>
                                </Col>
                            </Row>
                            {
                                nhanVien?.isQuanNhan &&
                                <Row>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Ngày nhập ngũ</div>
                                            <label>{dateCommon.formatDate(nhanVien?.ttQuanDoi.ngayNhapNgu)}</label>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Ngày xuất ngũ</div>
                                            <label>{dateCommon.formatDate(nhanVien?.ttQuanDoi.ngayXuatNgu)}</label>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="mb-1">
                                            <div>Nơi nhập ngũ</div>
                                            <label>{nhanVien?.ttQuanDoi.donViNhapNgu}</label>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
            },            
        ];

        return tabs.filter(tab => !tab.condition);
    };

    return (<section style={{ paddingBottom: "52px" }}>
        <ContentHeader title="Thông tin nhân sự" />
        {openModalXoa && <ModalTextForm show={openModalXoa}
            title="Xoá nhân sự"
            handleClose={() => setOpenModalXoa(false)}
            handleSave={() => xoa()}>
            Bạn có đồng ý xóa nhân sự này không?
        </ModalTextForm>}
        <Row >
            <Col span="24">
                <Tabs
                    defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Thông tin cá nhân',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content">
                                    <Row>
                                        <Col span="6">
                                            <div className="text-center mb-3">
                                                <img
                                                    className="profile-user-img img-fluid img-circle"
                                                    src={
                                                        nhanVien?.avatar == null || nhanVien?.avatar === ""
                                                            ? defaultAvatarImg
                                                            : `/${nhanVien?.avatar.replace(/\\/g, "/")}`
                                                    }
                                                    alt="User profile picture"
                                                />
                                            </div>
                                            <div className="text-center"><label className="mb-1">{nhanVien?.ma?.toUpperCase()}</label></div>
                                        </Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Tên nhân viên</div>
                                                <label>{nhanVien.hoTen}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Tình trạng hôn nhân</div>
                                                <label>{nhanVien?.isKetHon ? "Đã kết hôn" : "Chưa kết hôn"}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Email</div>
                                                <label>{nhanVien?.email}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Quốc tịch</div>
                                                <label>{nhanVien?.tenQuocTich}</label>
                                            </div>
                                        </Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Giới tính</div>
                                                <label>{nhanVien?.gioiTinh === 0 ? "Nam" : "Nữ"}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Ngày sinh</div>
                                                <label>{dateCommon.formatDate(nhanVien?.ngaySinh)}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Điện thoại</div>
                                                <label>{nhanVien?.dienThoai}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Dân tộc</div>
                                                <label>{nhanVien?.tenDanToc}</label>
                                            </div>
                                        </Col>
                                        <Col span="5">
                                            <div className="mb-1">
                                                <div>Tôn giáo</div>
                                                <label>{nhanVien?.tenTonGiao}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Số CMND/CCCD</div>
                                                <label>{nhanVien.cccd}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Ngày cấp CCCD</div>
                                                <label>{dateCommon.formatDate(nhanVien?.ngayCapCCCD)}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Nơi cấp CMND/CCCD</div>
                                                <label>{nhanVien.noiCapCCCD}</label>
                                            </div>
                                            
                                        </Col>
                                        <Col span={5}>
                                            <div className="mb-1">
                                                <div>Nơi sinh</div>
                                                <label>{nhanVien?.noiSinh}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Quê quán</div>
                                                <label>{nhanVien?.queQuan}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Số tài khoản</div>
                                                <label>{nhanVien?.soTKNganHang}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Ngân hàng</div>
                                                <label>{nhanVien?.tenNganHang}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span="6"></Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Trình độ văn hóa</div>
                                                <label>{nhanVien?.tenTrinhDoVanHoa}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Trình độ học vấn</div>
                                                <label>{nhanVien?.tenHocHam}</label>
                                            </div>
                                        </Col>
                                        <Col span="4">
                                            <div className="mb-1">
                                                <div>Mã số thuế</div>
                                                <label>{nhanVien?.maSoThue}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Thứ tự</div>
                                                <label>{nhanVien?.thuTu}</label>
                                            </div>
                                        </Col>
                                        <Col span="10">
                                            <div>
                                                <div>Nơi ở hiện tại</div>
                                                <label>{[
                                                    nhanVien?.soNhaNoiO,
                                                    nhanVien?.tenPhuongXaNoiO,
                                                    nhanVien?.tenTinhThanhNoiO
                                                ]
                                                    .filter(x => x)
                                                    .join(", ")}</label>
                                            </div>
                                            <div>
                                                <div>Nơi thường trú</div>
                                                <label>
                                                    {[
                                                        nhanVien?.soNhaThuongTru,
                                                        nhanVien?.tenPhuongXaThuongTru,
                                                        nhanVien?.tenTinhThanhThuongTru
                                                    ]
                                                        .filter(x => x)
                                                        .join(", ")}
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Tài liệu hồ sơ cá nhân',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Trạng thái</div>
                                                <label>{nhanVien?.fileHoSoCaNhan ? <Tag color="success">Đã có</Tag> : <Tag color="error">Chưa có</Tag>}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Thông tin file</div>
                                                {nhanVien.fileHoSoCaNhan ? (
                                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                                                        <PaperClipOutlined />
                                                        <a href={urlAdmin + nhanVien.fileHoSoCaNhan.duongDan.replace(/\\/g, "/")} target="_blank" rel="noreferrer">
                                                            {nhanVien.fileHoSoCaNhan.tenTep}
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <span style={{ color: '#999' }}>Chưa có hồ sơ</span>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Thông tin công việc',
                        children:
                            <div className="card pt-3 pb-2">
                                <div className="tab-content" style={{ marginLeft: "20px" }}>
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Trạng thái</div>
                                                <label>{tag}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Ngày vào làm</div>
                                                <label>{dateCommon.formatDate(nhanVien?.ngayVaoLam)}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <Row>
                                                <Col span="12">
                                                    <div className="mb-1">
                                                        <div>Ngày tính phép</div>
                                                        <label>{dateCommon.formatDate(nhanVien?.ngayTinhPhep)}</label>
                                                    </div>
                                                </Col>
                                                <Col span="12">
                                                    <div className="mb-1">
                                                        <div>Thời gian làm CQNN </div>
                                                        <label>{thoiGianCongTacCommon.hienThi(nhanVien?.soThangLamCQNN)}</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {(nhanVien.trangThai == 0 || nhanVien.trangThai == 3) &&
                                        <Row>
                                            <Col span="8">
                                                <div>
                                                    <div>Ngày nghỉ việc</div>
                                                    <label>{dateCommon.formatDate(nhanVien?.ngayNghiViec)}</label>
                                                </div>
                                            </Col>
                                            <Col span="8">
                                                <div>
                                                    <div>Nhóm lý do</div>
                                                    <label>{nhanVien?.tenNhomLyDoNghiViec}</label>
                                                </div>
                                            </Col>
                                            <Col span="8">
                                                <div>
                                                    <div>Lý do cụ thể</div>
                                                    <label>{nhanVien?.lyDoNghiViecCuThe}</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Phòng ban</div>
                                                <label>{nhanVien?.tenDonVi}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Chức danh chuyên môn</div>
                                                <label>{nhanVien?.tenChucDanhChuyenMon}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div>
                                                <div>Chức vụ</div>
                                                <label>{nhanVien?.tenChucVu}</label>
                                            </div>
                                            <div className="mb-1">
                                                <div>Trình độ LLCT</div>
                                                <label>{nhanVien?.tenTrinhDoLLCT}</label>
                                            </div>
                                        </Col>
                                        <Col span="8">
                                            <div className="mb-1">
                                                <div>Nhóm nhân sự</div>
                                                <label>{nhanVien?.tenNhomNhanSu}</label>
                                            </div>
                                            <div>
                                                <div>Số sổ BHXH</div>
                                                <label>{nhanVien?.soBHXH}</label>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                    },
                ]}>
                </Tabs>
            </Col>
        </Row>        
        <Row>
            <Col span="24">
                {/*<Tabs defaultActiveKey={hopDongInfo.id > 0 ? "1" : "2"}>
                    {generateTabs().map(tab => (
                        <Tabs.TabPane key={tab.key} tab={tab.label}>
                            {tab.children}
                        </Tabs.TabPane>
                    ))}
                </Tabs>*/}
                <Tabs defaultActiveKey={hopDongInfo.id > 0 ? "1" : "2"} items={generateTabs().map(tab => ({
                    key: tab.key,
                    label: tab.label,
                    children: tab.children,
                }))} />
            </Col>
        </Row>        
        <Row>
            <Col span="24">
                <QuaTrinhLamViecVaCongTacBox listCongTac={nhanVien.quaTrinhCongTacs} listLamViec={nhanVien.quaTrinhLamViecs} onSubmit={() => { }} isThemMoiLamViec={false} isThemMoiCongTac={false} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <QuaTrinhDaoTaoVaHocVanBox listHocVan={nhanVien.trinhDoHocVans} listDaoTao={nhanVien.quaTrinhDaoTaos} listToBan={nhanVien.toBans}  idNhanVien = { nhanVien.id } onSubmit={() => { }} isThemMoi={false} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <ChungChiBox listData={nhanVien.chungChis} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <DanhGiaXepLoaiBox listData={nhanVien.danhGiaXepLoais} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <KhenThuongBox listData={nhanVien.khenThuongs} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <KyLuatBox listData={nhanVien.kyLuats} onSubmit={() => { }} />
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <NguoiPhuThuocBox listTaiLieu={nhanVien.dsTaiLieuNguoiPhuThuocs} listData={nhanVien.nguoiPhuThuocs} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} isThemMoi={menu[Links.Luong.ChiTietThueThang] && !menu[Links.NhanVien.ChiTiet]} />
            </Col>
        </Row>
        {menu[Links.NhanVien.ChiTiet] &&
            <Row className="mt-1 mb-1">
                <Col span="24">
                    <FloatButton.Group
                        trigger="hover"
                        type="primary"
                        style={{ right: 50, bottom: 80 }}
                    >
                        <FloatButton
                            tooltip="Chỉnh sửa thông tin nhân sự"
                            className="hrm-btn-warning"
                            icon={<EditOutlined rev="" />}
                            onClick={() => {
                                navigate(Links.NhanVien.ChiTiet + "?id=" + nhanVien.id);
                            }}
                        />
                        <FloatButton
                            tooltip="Xuất hồ sơ nhân sự"
                            className="hrm-btn-success"
                            onClick={() => setOpenModalXuatFile(true)}
                            icon={<DownloadOutlined rev="" />}
                        />
                        <FloatButton
                            tooltip="In thông tin nhân sự"
                            className="hrm-btn-print"
                            icon={< PrinterOutlined rev="" />}
                            onClick={inBaoCao}
                        />
                        <FloatButton
                            tooltip="Xóa nhân sự"
                            className="hrm-btn-delete"
                            icon={<DeleteOutlined rev="" />}
                            onClick={() => setOpenModalXoa(true)}
                        />
                    </FloatButton.Group>
                </Col>
            </Row>}
        <Modal
            title="Tùy chọn xuất hồ sơ nhân sự"
            open={openModalXuatFile}
            onOk={() => xuatBaoCao(nhanVien.id, nhanVien.hoTen, loaiMauXuat)}
            onCancel={() => setOpenModalXuatFile(false)}
            okText="Xuất file"
            cancelText="Hủy"
            centered
        >
            <div style={{ padding: '12px 0' }}>
                <p style={{ marginBottom: 14, fontWeight: 500 }}>Vui lòng chọn mẫu biểu xuất thông tin:</p>
                <Radio.Group onChange={(e) => setLoaiMauXuat(e.target.value)} value={loaiMauXuat} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    <Radio value={2}>
                        <div>
                            <strong>Sơ yếu lý lịch (Mẫu 2C/TCTW-98 mới)</strong>
                            <div style={{ color: '#666', fontSize: 13 }}>Xuất theo biểu mẫu 2C/TCTW-98 mới (tệp MauThongTinNhanSuMoi.docx)</div>
                        </div>
                    </Radio>
                    <Radio value={1}>
                        <div>
                            <strong>Mẫu thông tin nhân sự (Mẫu cũ)</strong>
                            <div style={{ color: '#666', fontSize: 13 }}>Xuất theo mẫu thông tin hồ sơ nhân sự hiện tại (tệp HoSoNhanSuMoi.docx)</div>
                        </div>
                    </Radio>
                </Radio.Group>
            </div>
        </Modal>
        <div style={{ display: 'none' }}>
            <div ref={componentRef}>
                <InHoSoNhanVienMoi idNhanVien={nhanVien.id} ></InHoSoNhanVienMoi>
            </div>
        </div>
    </section>);
};

export default XemNhanVien;
